import { useEffect } from 'react';
import { useAppDispatch } from '../../../core/hooks/storeHooks';
import { ReturnTypeofSheetSectionsSelector } from '../../selectors/sheetUiSelector';
import { calculateSheetViewport } from '../../redux/sagas/views/viewsActions';
import Selections from './selections/Selections';
import { UseSheetTheme } from '../../hooks/useSheetTheme';
import { UseCellSelection } from '../../hooks/useCellSelection';
import AreaSelection from './selections/AreaSelection';

interface SheetTempViewsProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<
      UseSheetTheme,
      | 'isRtl'
      | 'selectionFill'
      | 'extendCircleBorderColor'
      | 'extendSelectionBorderColor'
      | 'isDarkTheme'
    >,
    Pick<UseCellSelection, 'handleSelectionInteraction'> {
  sheetId: string;
  windowWidth: number;
  windowHeight: number;
  gridWidth: number;
  gridHeight: number;
}

const SheetViews: React.FC<SheetTempViewsProps> = ({
  sheetId,
  windowWidth,
  windowHeight,
  ...props
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      calculateSheetViewport({
        sheetId,
        width: windowWidth,
        height: windowHeight,
      })
    );
  }, [
    sheetId,
    windowWidth,
    windowHeight,
    // props.cols,
    // props.rows,
    // props.colHeaderHeight,
    // props.colFilterHeight,
    // props.formulaBarHeight,
    // props.freezedColsSum,
    // props.freezedRowsSum,
    // props.rowHeaderWidth,
  ]);

  return (
    <Selections {...props} sheetId={sheetId} stageWidth={props.gridWidth} />
  );
};

export default SheetViews;
